
































































































import { noNumberRule } from "@/lib/rules/contactRule";
import { requiredRule } from "@/lib/rules/requiredRule";
import { vinRuleChecksum, vinRuleLength } from "@/lib/rules/vinRule";
import { calculateVinChecksum } from "@/lib/utility/calculateVinChecksum";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { ThgRegistrationDtoGen, ThgThgViewModelGen } from "@/services/thg/v1/data-contracts";
import { Component, Prop } from "vue-property-decorator";
import { deepCopy } from "@/lib/utility/deep-copy";
import { UserEntity } from "@/models/userEntity";

@Component({
  components: {}
})
export default class ThgQuoteWorkitemRegistrationCard extends DarkModeHighlightMixin {
  @Prop({ default: false })
  loading!: boolean;

  @Prop()
  selectedThg!: ThgThgViewModelGen;

  @Prop()
  selectedUser!: UserEntity;

  @Prop({ default: false })
  isResetValidation!: boolean;

  valid = false;

  registration: ThgRegistrationDtoGen = {} as any;

  /**
   * make sure that interval is gone
   */
  beforeDestroy() {
    document.removeEventListener("keyup", this.handleKeyDown);
  }

  setUsernameFromUserEntity() {
    if (this.selectedUser) {
      this.registration.firstname = deepCopy(this.selectedUser).firstName || ("" as any);
      this.registration.name = deepCopy(this.selectedUser).lastName || ("" as any);
    }
  }

  setCompanyFromUserEntity() {
    if (this.selectedUser) {
      this.registration.name = deepCopy(this.selectedUser).company || ("" as any);
      this.registration.firstname = "" as any;
    }
  }

  get startTextFieldRef(): any {
    return this.$refs.startTextField;
  }

  mounted() {
    document.addEventListener("keyup", this.handleKeyDown);
    this.registration = deepCopy(this.selectedThg.registration);
    this.fin = this.registration.identificationnumber as any;
    if (this.isResetValidation) {
      this.form.resetValidation();
    }
    this.startTextFieldRef.$parent.$el["1"].focus();
  }

  fin = "";
  calculatedChecksum = 0;
  isChecksum = "";

  vehicleClass = [
    { showText: "M1 (PKW)", value: "M1" },
    { showText: "N1 (LNF)", value: "N1" },
    { showText: "M3 (Bus)", value: "M3" },
    { showText: "Andere", value: "other" }
  ];

  day = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31"
  ];

  month = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];

  year = [
    "2024",
    "2023",
    "2022",
    "2021",
    "2020",
    "2019",
    "2018",
    "2017",
    "2016",
    "2015",
    "2014",
    "2013",
    "2012",
    "2011",
    "2010",
    "2009",
    "2008",
    "2007",
    "2006",
    "2005",
    "2004",
    "2003",
    "2002",
    "2001",
    "2000",
    "1999",
    "1998",
    "1997",
    "1996",
    "1995",
    "1994",
    "1993",
    "1992",
    "1991",
    "1990"
  ];

  driveType = [
    "0000",
    "0001",
    "0002",
    "0003",
    "0004",
    "0005",
    "0006",
    "0007",
    "0008",
    "0009",
    "0010",
    "0011",
    "0012",
    "0013",
    "0014",
    "0015",
    "0016",
    "0017",
    "0018",
    "0019",
    "0020",
    "0021",
    "0022",
    "0023",
    "0024",
    "0025",
    "0026",
    "0027",
    "0028",
    "0029",
    "0030",
    "0031",
    "0032",
    "0033",
    "0034",
    "0035",
    "0036",
    "0037",
    "0038",
    "9999"
  ];

  get formFin(): Vue & { validate: () => boolean } {
    return this.$refs.fin as Vue & { validate: () => boolean };
  }

  get form(): Vue & { resetValidation: () => boolean } {
    return this.$refs.form as Vue & { resetValidation: () => boolean };
  }

  validate() {
    if (this.fin != "") {
      this.formFin.validate();
    }
  }

  reset() {
    this.fin = "";
    this.calculatedChecksum = 0;
    this.isChecksum = "";
    this.registration = {} as any;
  }

  get getChecksumText() {
    return "Check:" + calculateVinChecksum(this.fin);
  }

  uppercase() {
    this.fin = this.fin.toUpperCase();
  }

  checkfin() {
    this.calculatedChecksum = calculateVinChecksum(this.fin);
  }

  async submit() {
    this.registration.identificationnumber = this.fin as any;
    this.$emit("submit", this.registration);
    this.reset();
  }

  /**
   * Rules
   */

  get requiredRules() {
    const rules = [];

    rules.push(requiredRule());

    return rules;
  }

  get vinRules() {
    const rules = [];

    rules.push(requiredRule());
    rules.push(vinRuleLength());
    rules.push(vinRuleChecksum("Prüfziffern stimmen nicht überein", +this.isChecksum));

    return rules;
  }

  get noNumberAndRequiredRules() {
    const rules = [];

    rules.push(requiredRule());
    rules.push(noNumberRule());

    return rules;
  }

  get noNumberRules() {
    const rules = [];
    rules.push(noNumberRule());

    return rules;
  }

  /**
   * default prefill
   */
  handleKeyDown(event: any) {
    if (event.altKey === true && event.shiftKey === false && event.key === "Enter") {
      this.setUsernameFromUserEntity();
    }

    if (event.altKey === true && event.shiftKey === true && event.key === "Enter") {
      this.setCompanyFromUserEntity();
    }

    if (event.ctrlKey === true && event.key === "Enter") {
      this.registration.vehicleClass = "M1" as any;
      this.registration.driveTyp = "0004" as any;
    }
  }
}
